import { toDateString } from '../../../../utils/TimeUtils';
import { DEFAULT_DATE, DEFAULT_DATE_TIME } from '../../../../components/common/Constants';
import { DateTimePicker } from '../../../../components/dateTimePicker/DateTimePicker';
import { FilterButton } from '../../../../components/buttons/FilterButton';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '../../../../components/checkbox/Checkbox';

export const HistoryFilter = ({ filter, doFilter, employees, actionTypes }) => {
    const { t } = useTranslation();

    const handleKeyUp = (event) => {
        if (event.key === 'Enter') {
            doFilter();
        }
    };

    const setFrom = (value) => {
        filter.from = toDateString(value, DEFAULT_DATE_TIME);
    };

    const setTill = (value) => {
        filter.till = toDateString(value, DEFAULT_DATE_TIME);
    };

    const setDate = (value) => {
        filter.date = toDateString(value, DEFAULT_DATE);
    };

    return (
        <div className={'filter'} id={'filter-element'}>
            <div className={'mb-3'}>
                <Checkbox object={filter}
                          field={'groupByDay'}
                          label={t('history:groupByDay')}
                          id={'groupByDay'}>
                </Checkbox>
            </div>
            <div className={'mb-3'}>
                <span>{t('filter:title')}</span>
                <input type={'text'}
                       className={'form-control'}
                       id={'filter-by-title-id'}
                       defaultValue={filter.title}
                       onKeyUp={handleKeyUp}
                       onChange={(e) => filter.title = e.target.value} />
            </div>
            <div className={'mb-3'}>
                <span>{t('filter:invoice')}</span>
                <input type={'text'}
                       className={'form-control'}
                       id={'filter-by-invoice-id'}
                       defaultValue={filter.invoice}
                       onKeyUp={handleKeyUp}
                       onChange={(e) => filter.invoice = e.target.value} />
            </div>
            <div className={'mb-3'}>
                <span>{t('filter:employee')}</span>
                <select className={'form-select'}
                        id={'filter-by-employee-id'}
                        defaultValue={filter.employeeId}
                        onChange={(e) =>
                            filter.employeeId = e.target.value !== ''
                                ? e.target.value
                                : null}>
                    <option></option>
                    {employees.map((employee) => {
                        return (
                            <option value={employee.id} key={employee.value}>
                                {employee.value}
                            </option>
                        );
                    })}
                </select>
            </div>
            <div className={'mb-3'}>
                <span>{t('filter:actionType')}</span>
                <select className={'form-select'}
                        id={'filter-by-type-id'}
                        defaultValue={filter.type}
                        onChange={(e) =>
                            filter.type = e.target.value !== ''
                                ? e.target.value
                                : null}>
                    <option></option>
                    {actionTypes.map((type) => {
                        return (
                            <option value={type} key={type}>
                                {t('history:' + type)}
                            </option>
                        );
                    })}
                </select>
            </div>
            <div className={'mb-3'}>
                <span>{t('filter:eventTimeFrom')}</span>
                <DateTimePicker value={filter.from}
                                onChange={setFrom}
                                dateFormat={DEFAULT_DATE_TIME}
                                showTime={true}>
                </DateTimePicker>
            </div>
            <div className={'mb-3'}>
                <span>{t('filter:eventTimeTill')}</span>
                <DateTimePicker value={filter.till}
                                onChange={setTill}
                                dateFormat={DEFAULT_DATE_TIME}
                                showTime={true}>
                </DateTimePicker>
            </div>
            <div className={'mb-3'}>
                <span>{t('history:date')}</span>
                <DateTimePicker value={filter.date}
                                onChange={setDate}
                                dateFormat={DEFAULT_DATE}>
                </DateTimePicker>
            </div>
            <div className={'center'}>
                <FilterButton onClick={doFilter}></FilterButton>
            </div>
        </div>
    );
};